var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMwheelloader(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 203,
    viewBox: "0 0 206 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.730938 101.297C0.730935 156.81 46.5266 201.797 103 201.797C159.473 201.797 205.269 156.81 205.269 101.297C205.269 45.784 159.473 0.796873 103 0.79687C46.5267 0.796868 0.73094 45.784 0.730938 101.297Z",
    fill: "#D6D7D8",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 180.797C146.907 180.797 182.5 145.204 182.5 101.297C182.5 57.3902 146.907 21.7969 103 21.7969C59.0934 21.7969 23.5 57.3902 23.5 101.297C23.5 145.204 59.0934 180.797 103 180.797Z",
    fill: "#F6F7F9",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.767 81.5306C117.056 75.8266 108.962 72.5372 100.063 73.4471C87.2053 74.7418 76.6245 85.1699 75.188 98.0126C73.261 114.984 86.3995 129.297 102.971 129.297C114.148 129.297 123.748 122.753 128.232 113.34C129.353 110.995 127.672 108.301 125.079 108.301C123.783 108.301 122.556 109.001 121.996 110.155C118.037 118.659 108.542 124.048 98.1715 121.738C90.3935 120.024 84.1221 113.69 82.4755 105.921C79.5325 92.3436 89.868 80.3058 102.971 80.3058C108.787 80.3058 113.973 82.7204 117.756 86.5347L112.466 91.8187C110.259 94.0233 111.8 97.8026 114.919 97.8026H127.496C129.423 97.8026 131 96.2279 131 94.3033V81.7406C131 78.6261 127.216 77.0514 125.009 79.256L122.767 81.5306Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwheelloader);
export default __webpack_public_path__ + "static/media/mwheelloader.e35edab9d6da2392dcf7d83be7c1e2a2.svg";
export { ForwardRef as ReactComponent };